export const CONTACT_TOPICS = ['cloud-demo', 'research', 'press', 'other'] as const
export type ContactTopic = (typeof CONTACT_TOPICS)[number]

export function subjectFromTopic(topic: unknown): ContactTopic | '' {
  return typeof topic === 'string' && (CONTACT_TOPICS as ReadonlyArray<string>).includes(topic)
    ? (topic as ContactTopic)
    : ''
}
